import { Component, Input } from '@angular/core';

@Component({
  selector: 'piqet-angular-inline-loader',
  templateUrl: './inline-loader.component.html',
  styleUrls: ['./inline-loader.component.css'],
})
export class InlineLoaderComponent {
  @Input() message = 'Loading';
  // If don't want to show dots than use minimal type
  @Input() type = 'default'; // small-spinner | default | large | minimal | centered
}
